import React from 'react'
import { Avatar } from '@chakra-ui/react'
import { Text, Flex, HStack, SimpleGrid } from '@chakra-ui/react'

import InfoItem, { InfoText } from '~components/shared/info-item'
import { ClientFieldsFragment, ClientPortalAppFieldsFragment } from '~graphql/generated/graphql'
import AdminIdButton from '~components/shared/buttons/admin-id-button'
import { SupabaseEntities } from '~config/constants'
import AddressDisplay from '~components/shared/address-display'
import ClientPhonesInfo from './phone-settings'
import {
    formatEmail,
    getClientFullName,
    getClientSecondaryName,
} from '~utils/helpers'
import SharedStack from '~components/shared/wrappers/shared-stack'
import ClientPortalAppTags from '~components/shared/tags/client-portal-app-tags'

interface Props {
    client: Pick<
        ClientFieldsFragment & ClientPortalAppFieldsFragment,
        | 'id'
        | 'user'
        | 'client_phones'
        | 'first_name'
        | 'last_name'
        | 'phone'
        | 'address'
        | 'email'
        | 'pms_id'
        | 'secondary_first_name'
        | 'secondary_last_name'
        | 'has_portal_account'
        | 'has_mobile_app'
    >
}

export default function DetailedClientHeader({ client }: Props) {
    const secondaryName = getClientSecondaryName(client)

    return (
        <>
            <Flex mb={4} justifyContent="space-between" alignItems="center">
                <HStack spacing={4}>
                    <Avatar
                        src={client.user?.avatar_url || ''}
                        name={getClientFullName(client, true) || ''}
                    />
                    <SharedStack spacing={0}>
                        <Text
                            fontWeight="bold"
                            fontSize="xl"
                            lineHeight="normal"
                        >
                            {getClientFullName(client)}
                        </Text>
                        {secondaryName && (
                            <Text color="gray.500">{`& ${secondaryName}`}</Text>
                        )}
                        <SharedStack row fit pt={1}>
                            <ClientPortalAppTags client={client} />
                        </SharedStack>
                    </SharedStack>
                </HStack>
                <AdminIdButton
                    entity={SupabaseEntities.Client}
                    id={client.id}
                    pms_id={client.pms_id}
                />
            </Flex>
            <SimpleGrid columns={2} spacing={4} mb={4}>
                <InfoItem
                    label="Email"
                    info={<InfoText>{formatEmail(client?.email)}</InfoText>}
                />
                <InfoItem
                    label="Address"
                    info={
                        <InfoText>
                            {client.address ? (
                                <AddressDisplay address={client.address} />
                            ) : null}
                        </InfoText>
                    }
                />
            </SimpleGrid>
            <ClientPhonesInfo client={client} />
        </>
    )
}
